import { DEVICE_SIZES, type DevicePreset } from "@codvero/shared";

/** A computer's page is at least this wide: narrower panes show it scaled down rather than the site's narrow layout. */
const DESKTOP_MIN_WIDTH = 1280;

/**
 * The page's CSS viewport for a device and the pane's size. A computer uses the pane itself when it is wide enough,
 * otherwise 1280 wide and landscape (720–960 tall, following the pane's shape); a tablet or a phone its fixed size.
 */
export function viewportFor(device: DevicePreset, host: { w: number; h: number }): { w: number; h: number } {
  if (device !== "desktop") return { w: DEVICE_SIZES[device].width, h: DEVICE_SIZES[device].height };
  if (!host.w || !host.h) return { w: DEVICE_SIZES.desktop.width, h: DEVICE_SIZES.desktop.height };
  if (host.w >= DESKTOP_MIN_WIDTH) return { w: host.w, h: Math.max(240, host.h) };
  return { w: DESKTOP_MIN_WIDTH, h: Math.min(960, Math.max(720, Math.round((DESKTOP_MIN_WIDTH * host.h) / host.w))) };
}
